export default __webpack_public_path__ + "static/media/document-logo-2-active.33d75642.svg";